/* eslint-disable no-unused-vars */
/* eslint-disable no-console */

import {
    call, put, select,
} from 'redux-saga/effects'

import { LAUNCHER_TAG } from 'common/tags'
import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'
import Lifecycle from 'common/modules/lifecycle'

import PopupsProcessor from 'common/modules/popupsProcessor'

import { creators } from '../actions'
import selectors from '../selectors'

export function* handleDecorators() {
    const { initializeDecorators, adBlockDetector } = yield select(Zoid.selectors.getXprops)
    const adBlocked = yield adBlockDetector()

    const decoratorPayload = yield select(selectors.decoratorPayload, adBlocked)

    initializeDecorators(decoratorPayload)
}

export function* handleMutators(dispatch, getState) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)

    const mutators = [
        {
            message: 'REGISTER/MENU',
            onMessage: (link) => {
                if (link === 'defaultPopup') {
                    dispatch(creators.showDefaultPopup())
                } else {
                    dispatch(creators.handleDirectLinks({ link }))
                }
            },
        },
        {
            message: 'REGISTER/PROMPT',
            onMessage: () => {
                const state = getState()

                const defaultPopup = Loader.selectors.getDefaultPopup(state)
                const userStatus = Loader.selectors.userStatus(state)
                const isLoggedIn = userStatus !== 'anonymous'
                const isPaying = userStatus === 'paying'

                const hasProducts = !!(defaultPopup?.products || []).length

                let shouldShowPopup

                if (
                    !!defaultPopup
                    && (
                        !isLoggedIn
                        || (isLoggedIn && !isPaying && hasProducts)
                    )
                ) {
                    shouldShowPopup = true
                }

                if (shouldShowPopup) {
                    dispatch(creators.showDefaultPopup())
                } else {
                    dispatch(creators.handleDirectLinks({}))
                }
            },
        },
        {
            message: 'REGISTER/FORM',
            onMessage: (email) => {
                dispatch(creators.handleSignupConfirmation({ email }))
            },
        },
        {
            message: 'REGISTER/PLAN_OPTION',
            onMessage: (planOptionId) => {
                dispatch(creators.handleDirectPlanLink({ planOptionId }))
            },
        },
        {
            message: 'REGISTER/CLOSE_PICO',
            onMessage: () => {
                dispatch(creators.closePico())
            },
        },
        {
            message: 'REGISTER/GET_LIFECYCLE_EVENTS',
            onMessage: async () => {
                const state = getState()
                const lifecycleEvents = Lifecycle.selectors.getEvents(state)

                return lifecycleEvents
            },
        },
        {
            message: 'REGISTER/POPUP',
            onMessage: ({ popupId, gift, optionId }) => {
                dispatch(creators.showPopup({ popupId, gift, optionId }))
            },
        },
    ]

    let mutatorsHandled = 0

    const onMutatorHandled = () => {
        mutatorsHandled += 1

        if (mutatorsHandled === mutators.length) {
            dispatch(Lifecycle.creators.mutatorsReady())
        }
    }

    mutators.forEach(({
        message,
        onMessage,
    }) => {
        sendHostMessage(
            message,
            onMessage,
            onMutatorHandled,
        )
    })
}

export function* handleArticle() {
    const { hideArticle, releaseArticle } = yield select(Zoid.selectors.getXprops)
    const scopedLoader = yield select(Loader.selectors.topScopeLoader)
    const linkColor = yield select(Loader.selectors.linkColor)

    const {
        publisher,
        locked: isArticleLocked,
        userArticle: userHasArticle,
    } = scopedLoader

    if (isArticleLocked) {
        yield hideArticle({
            style: linkColor,
            text: publisher?.article_lock_button_text || 'Read More',
        })
    } else {
        releaseArticle()

        if (!userHasArticle) {
            yield put(creators.purchaseArticle())
        }
    }
}

export default function* watchLoaderActions({ dispatch, getState }) {
    const { queryString = {} } = yield select(Zoid.selectors.getXprops)
    const popups = yield select(Loader.selectors.popups)

    yield handleDecorators()
    yield handleMutators(dispatch, getState)

    if (queryString.pn) {
        yield put(creators.handleDirectLinks({ link: queryString.pn, queryString }))
    } else if (queryString.pico_ui) {
        yield put(creators.handleDirectLinks({ link: queryString.pico_ui, queryString }))
    } else if (popups.length === 0) {
        // need to handle article purchase (needs to look at the locked key of the loader)
        yield put(creators.showChild({ frame: LAUNCHER_TAG }))
    } else {
        yield put(creators.showChild({ frame: LAUNCHER_TAG }))

        yield put(
            yield call(
                PopupsProcessor.creators.set,
                {
                    payload: {
                        popups: popups.map(({
                            id,
                            trigger,
                        }) => ({ id, trigger })),
                    },
                },
            ),
        )

        yield put(
            yield call(
                PopupsProcessor.creators.run,
            ),
        )
    }
}
